import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import media from '../../styles/media.style';
import Placeholder from '../../components/Placeholder';
import Image from '../../components/ContentfulImage';
import { SCREEN_LOCKUP_WIDTH, MOBILE_PADDING } from '../../styles/variables.style';

const Section = styled.section`
  box-sizing: content-box;
  margin: 50px auto 0;
  max-width: ${SCREEN_LOCKUP_WIDTH}px;
  padding: 0 ${MOBILE_PADDING}px;
  width: calc(100% - ${MOBILE_PADDING * 2}px);

  ${media.tabletL`
    margin: 95px auto 130px;
  `};
`;

const Entry = styled.div`
  ${media.tabletL`
    display: flex;
  `};

  &:first-child {
    .details {
      &::after {
        top: 0;
      }
    }
  }

  &:last-child {
    .details {
      &::before {
        height: calc(100% - 70px);
      }
    }
  }
`;

const ImageContainer = styled.div`
  margin-bottom: 30px;

  ${media.tabletL`
    display: flex;
    height: 150px;
    justify-content: flex-start;
    margin-bottom: 70px;
    width: 50%;
  `};
`;

const Details = styled.div`
  padding-bottom: 60px;
  position: relative;

  ${media.tabletL`
    padding-bottom: 70px;
    padding-left: 70px;
    width: 50%;

    &::before {
      background-color: black;
      content: '';
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 2px;
    }

    &::after {
      background-color: black;
      border-radius: 14px;
      content: '';
      height: 14px;
      left: -6px;
      position: absolute;
      top: 10px;
      width: 14px;
    }
  `};
`;

const Title = styled.div`
  font-size: 30px;
  line-height: 1.2;
  letter-spacing: 0.3px;
`;

const Description = styled.div`
  margin-top: 15px;
  width: 100%;
`;

const ListSection = ({ entries, screenSize }) => (
  <Section>
    {entries.map(entry => (
      <Entry key={entry.entryId || entry.key}>
        <ImageContainer>
          {entry.image ? (
            <Image
              src={entry.image}
              options={
                screenSize > 1 ? { h: '100%', w: '100%', objectFit: 'contain', objectPosition: 'left' } : { w: '100%' }
              }
            />
          ) : (
            <Placeholder w={screenSize > 1 ? '65%' : '100%'} h="150px" />
          )}
        </ImageContainer>

        <Details className="details">
          <Title>{entry.title || <Placeholder h="35px" w="100px" />}</Title>
          <Description>{entry.description || <Placeholder h="55px" w="100%" />}</Description>
        </Details>
      </Entry>
    ))}
  </Section>
);

ListSection.defaultProps = {
  entries: [{ key: 1 }, { key: 2 }, { key: 3 }, { key: 4 }, { key: 5 }],
};

ListSection.propTypes = {
  entries: PropTypes.arrayOf(PropTypes.shape()),
  screenSize: PropTypes.number.isRequired,
};

const mapState = state => ({
  screenSize: state.screenSize,
});

export default connect(mapState)(ListSection);



// WEBPACK FOOTER //
// ./src/pages/HeritagePage/ListSection.js